import { baseApi } from '@/services/BaseApi';

export const ProductPickerServices = {
  getAllProducts: (params: any) => {
    return baseApi.get('/api/product/getAllProducts', { params: params });
  },
};
